import _ from 'lodash'

const MENORQUINA_SCROLLSPY_CONFIG = {
    section: _.select( '.c-section--menorquina-history' ) 
}

export default MENORQUINA_SCROLLSPY_CONFIG